"use strict";

var _slicedToArray = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var context_1 = __importDefault(require("./context"));

var tenant_1 = __importDefault(require("./tenant"));

var Property =
/*#__PURE__*/
function (_context_1$default) {
  _inherits(Property, _context_1$default);

  function Property(id) {
    var _this;

    var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new tenant_1.default();

    _classCallCheck(this, Property);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Property).call(this, "p", id, tenant));
    _this.type = "p";
    _this.tenant = tenant;
    return _this;
  }

  _createClass(Property, null, [{
    key: "fromString",
    value: function fromString(context) {
      var _context$split = context.split("/p/"),
          _context$split2 = _slicedToArray(_context$split, 2),
          remaining = _context$split2[0],
          pid = _context$split2[1];

      return new Property(pid, tenant_1.default.fromString(remaining));
    }
  }, {
    key: "test",
    value: function test(context) {
      var _context$split3 = context.split("/p/"),
          _context$split4 = _slicedToArray(_context$split3, 2),
          remaining = _context$split4[0],
          pid = _context$split4[1];

      return typeof pid === "string" && pid.length > 0 && tenant_1.default.test(remaining);
    }
  }]);

  return Property;
}(context_1.default);

exports.default = Property;